import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_LOAD_ITEM_DETAILS_BEGIN,
  COLLECTIONS_LOAD_ITEM_DETAILS_SUCCESS,
  COLLECTIONS_LOAD_ITEM_DETAILS_FAILURE,
  COLLECTIONS_LOAD_ITEM_DETAILS_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadItemDetails(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_LOAD_ITEM_DETAILS_BEGIN,
    });
    const { projectId, decryptFields, collectionName, itemId, version } = args;
    const config = builderSurfaceJsonContentHeader(projectId);
    if (decryptFields) config.params = { decryptFields: true };
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${collectionName}/item-with-inner-detail/${itemId}/`,
        config,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_LOAD_ITEM_DETAILS_SUCCESS,
              data: res.data,
            });
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_LOAD_ITEM_DETAILS_FAILURE,
              data: { error: 'Failed' },
            });
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_LOAD_ITEM_DETAILS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadItemDetailsError() {
  return {
    type: COLLECTIONS_LOAD_ITEM_DETAILS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_LOAD_ITEM_DETAILS_BEGIN:
      return {
        ...state,
        loadItemDetailsPending: true,
        loadItemDetailsError: null,
      };

    case COLLECTIONS_LOAD_ITEM_DETAILS_SUCCESS:
      return {
        ...state,
        loadItemDetailsPending: false,
        loadItemDetailsError: null,
        selectedItemWithDetails: action.data,
        isOpenItemDetail: !state.isOpenItemDetail
          ? !state.isOpenItemDetail
          : state.isOpenItemDetail,
      };

    case COLLECTIONS_LOAD_ITEM_DETAILS_FAILURE:
      return {
        ...state,
        loadItemDetailsPending: false,
        loadItemDetailsError: action.data.error,
      };

    case COLLECTIONS_LOAD_ITEM_DETAILS_DISMISS_ERROR:
      return {
        ...state,
        loadItemDetailsError: null,
      };

    default:
      return state;
  }
}
